import React from "react";
import { PageLayout } from "../components/page-layout";
import ContactList from "../components/contacts/contact-list";

export const AllContactsPage = () => (
  <PageLayout>
    <ContactList />
  </PageLayout>
);
